module.exports = __webpack_public_path__ + "img/schets-19.651a531d.jpg";